// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"462224a5","787":"4cc5d4af","981":"0144de58"}[chunkId] + ".chunk.js";
};